import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Observable } from 'rxjs';
import { LanguageConfig } from 'src/app/app.models';

@Component({
  selector: 'app-sign-in-header',
  templateUrl: './sign-in-header.component.html',
  styleUrls: ['./sign-in-header.component.scss']
})
export class SignInHeaderComponent {
  // Todo: Tim: #techdebt - rename this component, since it will be used beyond the sign-in flow
  @Output() backButtonClickEvent = new EventEmitter<void>();
  @Input() languageList: LanguageConfig[];
  @Input() displayBackButton: boolean = true;
  @Input() cmsLabels$: Observable<any>; // TODO: Tim: fix types/any

  backButton() {
    this.backButtonClickEvent.emit();
  }
}
